//@flow
import * as React from 'react'
import type { UranusQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const UranusQualityReview=(props:UranusQualityReview$Props)=>{
    const uranus = props.uranus
    let isVisible = false

    if (uranus.reviewQuestions && uranus.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'uranusQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'orionPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(uranus.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default UranusQualityReview


// WEBPACK FOOTER //
// ./src/views/ProjectUranus/UranusQualityReview.js